import { STATUS_INITIAL, STATUS_PROCESSING, STATUS_SHIPPED } from '../constants/orderStatuses'

// D1: the 3 pre-carrier fulfillment nodes live on the ORDER (order_histories)
// and are shared by every package. The 3 carrier nodes are per-package.
export const PRE_CARRIER_STATUSES = [STATUS_INITIAL, STATUS_PROCESSING, STATUS_SHIPPED]

const ts = (v) => {
    const n = new Date(v).getTime()
    return Number.isFinite(n) ? n : 0
}

// For the carrier tail, an undated/invalid timestamp must sort to the END
// (not the front, which `ts` would do by coercing to epoch 0).
const tsOrLast = (v) => {
    const n = new Date(v).getTime()
    return Number.isFinite(n) ? n : Infinity
}

export function buildPackageTimeline(orderHistories = [], pkg = {}) {
    const seen = new Set()
    const prefix = (orderHistories || [])
        .slice()
        .sort((a, b) => ts(a.reference_timestamp) - ts(b.reference_timestamp))
        .reduce((acc, h) => {
            const status = h.new_status ?? h.status
            if (!PRE_CARRIER_STATUSES.includes(status) || seen.has(status)) return acc
            seen.add(status)
            acc.push({
                status,
                reference_timestamp: h.reference_timestamp,
                metadata: h.metadata || {},
                source: 'order',
            })
            return acc
        }, [])

    const tail = ((pkg || {}).tracking_history || [])
        .map((e) => ({
            status: e.status,
            reference_timestamp: e.reference_timestamp,
            metadata: e.metadata || {},
            source: 'package',
        }))
        .sort((a, b) => tsOrLast(a.reference_timestamp) - tsOrLast(b.reference_timestamp))

    // The shared pre-carrier prefix always renders before the per-package
    // carrier tail, regardless of individual timestamps (#12): a carrier scan
    // can be recorded before the WMS finalizes 'shipped'. Undated/invalid
    // carrier timestamps sort to the end of the tail, never ahead of it (#11).
    return [...prefix, ...tail]
}
